import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import moment from 'moment';


@Component({
    components: {
        Modal,
    }
})
export default class ProducerListNotificationModal extends Vue {
    
    private list: any | null = null
    private items: any = []
    private title = '通知'
    private baseUrl = '/producer_notification';
    private withHidden = false

    private isHidden = false
    private isToggleHidden = false
    private isToggleProducer = true
    private isToggleShippingGroup = true
    private isDeletable = true
    private isEditable = true;
    private isLoading = false;
    private withRead = false;
    private producerNotification = [] as any[];
    private selectedNotificationId = ''
    private tableKey = 0;

    @Prop() 
    isShowProducerListNotificationModal!: boolean

    @Prop()
    producerId!: string

    @Prop()
    producerName!: string

    @Prop()
    readFlag!: boolean

    @Watch('isShowProducerListNotificationModal')
    private showNotification() {
        if(this.isShowProducerListNotificationModal){
        if(this.readFlag){
            this.getNotifications(this.readFlag)
            this.withRead = this.readFlag
        }else{
            this.getNotifications(false)
        }
        }
    }

    private getNotifications(withRead: boolean) {
        this.list = null
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_read=${withRead}&producer_id=${this.producerId}`).then(res => {
            this.producerNotification = res.producerNotification
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    private toggleReadItems(value: boolean) {
        this.getNotifications(this.withRead)
    }


    private toggleReadCheck(producerNotification:any){
        this.selectedNotificationId = producerNotification.id
        this.isLoading = true

        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.selectedNotificationId}`).then(() => {
            this.getNotifications(this.withRead)
            this.$toasted.success('変更を保存しました。')
             this.tableKey++;

        })
        .catch(() => {
            this.$toasted.error('変更に失敗しました。')
        })
        .finally(() => {
            this.isLoading = false
        })

    }

    @Emit('cancel')
    private cancel() {
        this.isShowProducerListNotificationModal = false
        this.$root.$emit('header-inert', false);

    }

    closeModal(){
        this.withRead = false
        this.$emit('update:isShowProducerListNotificationModal', false);
        this.$emit('update:isRefresh', true);
        this.$root.$emit('header-inert', false);
    }
    
    private changeDateFormat(inputDate: string): string {
        const utcDate = new Date(inputDate);
        const newDateFormat= moment(utcDate).format('YYYY/MM/DD HH:mm:ss')
        return newDateFormat;
    }
}